import { API_MARKETING_PATH, getMarketingClient } from '../api';

export type IsCanvaAuthorizedStatusResponse = { status: 'AUTHORIZED' | 'UNAUTHORIZED' };

export type CanvaAuthorizationResponse = { url: string };

export async function isCanvaAuthorized(): Promise<IsCanvaAuthorizedStatusResponse> {
  const client = await getMarketingClient();

  const { data } = await client.get<IsCanvaAuthorizedStatusResponse>(`${API_MARKETING_PATH}/is-authorized`);
  return data;
}

export async function authorizeCanva(redirectPath: string): Promise<CanvaAuthorizationResponse> {
  const client = await getMarketingClient();

  const { data } = await client.get<CanvaAuthorizationResponse>(`${API_MARKETING_PATH}/authorize?redirect_path=${redirectPath}`, { withCredentials: true });
  return data;
}
